import Link from 'next/link';
import { formatFeedTime } from '@/platform/feed/feedUtils';
import type { ClaimSummary } from '@/domains/paydirt/claims/api';

type DraftClaimCardProps = {
  claim: ClaimSummary;
};

export function DraftClaimCard({ claim }: DraftClaimCardProps) {
  return (
    <article className="feed-card feed-card--draft">
      <div className="feed-card__head">
        <span className="feed-card__badge">Draft</span>
        {claim.createdAt && <span className="text-muted feed-card__time">{formatFeedTime(claim.createdAt)}</span>}
      </div>
      <h3 className="feed-card__title">{claim.title}</h3>
      <p className="feed-card__excerpt text-muted">Finish proof and publish your haul report.</p>
      <Link href={`/claims/new/?resume=${claim.id}`} className="btn btn-primary">
        Continue
      </Link>
    </article>
  );
}
